import React from 'react';
import styles from './error-404-page.module.css';

import { Box, Split } from '@dropbox/dig-foundations';
import { LookMagnifyingGlassSpot } from '@dropbox/dig-illustrations/dist/cjs/spot/look-magnifying-glass';
import { FormattedMessage } from 'react-intl';
import { Text, Link } from '@dropbox/dig-components/typography';

export default function Error404Page() {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <LookMagnifyingGlassSpot width="300px" />

      <Split
        direction="vertical"
        alignX="center"
        gap="Micro XLarge"
        className={styles.textContainer}
      >
        <Split.Item>
          <Text className={styles.title}>
            <FormattedMessage
              id=""
              description="Error 404 page title"
              defaultMessage="Error (404)"
            />
          </Text>
        </Split.Item>

        <Split.Item>
          <Text size="xlarge">
            <FormattedMessage
              id=""
              description="Error 404 page description"
              defaultMessage="We can't find the page you're looking for."
            />
          </Text>
        </Split.Item>
      </Split>

      <Split
        direction="vertical"
        alignX="center"
        gap="Micro Small"
        className={styles.textContainer}
        paddingTop="Macro Large"
      >
        <Split.Item>
          <Text>
            <FormattedMessage
              id=""
              description="Helpful links info"
              defaultMessage="Here are a few links that may be helpful:"
            />
          </Text>
        </Split.Item>
        <Split.Item>
          <Text>
            <Link href="https://faq.hellosign.com/" hasNoUnderline isBold>
              <FormattedMessage
                id=""
                description="Button in 404 error page, when clicked reroutes user to help page"
                defaultMessage="Get help"
              />
            </Link>
          </Text>
        </Split.Item>
        <Split.Item>
          <Text>
            <Link href="/info/pricing" hasNoUnderline isBold>
              <FormattedMessage
                id=""
                description="Button in 404 error page, when clicked reroutes user to pricing page"
                defaultMessage="See pricing"
              />
            </Link>
          </Text>
        </Split.Item>
        <Split.Item>
          <Text>
            <Link
              href="https://faq.hellosign.com/hc/en-us/requests/new"
              hasNoUnderline
              isBold
            >
              <FormattedMessage
                id=""
                description="Button in 404 error page, when clicked reroutes user to contactus page"
                defaultMessage="Contact us"
              />
            </Link>
          </Text>
        </Split.Item>
      </Split>
    </Box>
  );
}
